import { render, staticRenderFns } from "./orderDetailsRow.vue?vue&type=template&id=67a23f5e&"
import script from "./orderDetailsRow.vue?vue&type=script&lang=js&"
export * from "./orderDetailsRow.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailsRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports